export default __webpack_public_path__ + "static/media/KOD0116-min.1ac5c1b8.webp";